import React, { useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Typography } from '@material-ui/core';
import { includes } from 'lodash';

import './dealStatusView.scss';
import { getDealStatusStyles } from 'utils/staffing/status';
import { DEAL_ERROR_STATUS_STATES } from 'constants/staffing';
import StatusErrorDialog from 'components/Dialogs/StatusErrorDialog';

/**
 * Deal status pill (and optional time-in-status label). When the deal is in an
 * error status and `statusError` is set, the pill opens a dialog with the full
 * error instead of a hover tooltip.
 */
const DealStatusView = props => {
  const { status, time, statusError } = props;
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);

  const hasClickableError =
    Boolean(statusError) && includes(Object.values(DEAL_ERROR_STATUS_STATES), status);

  const statusStyles = getDealStatusStyles(status);
  const statusTitle = statusStyles.title;

  const handlePillClick = event => {
    // Deal list cards navigate from nearby click targets; keep the dialog open action isolated.
    event.stopPropagation();
    event.preventDefault();
    setIsErrorDialogOpen(true);
  };

  return (
    <div className="d-flex align-items-center flex-wrap dealStatusView">
      <div
        className={cx('mr-1', 'deal-card-body-status', statusStyles.containerClassname)}
        onClick={hasClickableError ? handlePillClick : undefined}
        onKeyDown={
          hasClickableError
            ? event => {
                if (event.key === 'Enter' || event.key === ' ') {
                  handlePillClick(event);
                }
              }
            : undefined
        }
        role={hasClickableError ? 'button' : undefined}
        tabIndex={hasClickableError ? 0 : undefined}
        style={hasClickableError ? { cursor: 'pointer' } : undefined}
        title={hasClickableError ? 'Click to view error details' : undefined}
      >
        <Typography className="deal-card-body-status-text">{statusTitle}</Typography>
      </div>
      {typeof time !== 'undefined' && time !== null && (
        <Typography className={cx('deal-card-body-day-text', statusStyles.textClassname)}>
          {time}
        </Typography>
      )}
      {hasClickableError && (
        <StatusErrorDialog
          isOpen={isErrorDialogOpen}
          onClose={() => setIsErrorDialogOpen(false)}
          title={statusTitle}
          statusError={statusError}
        />
      )}
    </div>
  );
};

DealStatusView.propTypes = {
  status: PropTypes.string,
  time: PropTypes.node,
  statusError: PropTypes.string,
};

export default DealStatusView;
